// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Zz7yk","content":"GlobalSearch_content__2eMYx"};